import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";

function Navbar() {
  const history = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    history("/");
    window.location.reload();
  };

  const { userId, username, jwt_token } = useSelector((state) => state.Auth);
  const uid = userId;
  //console.log("hhhj", username);
  const [menulist, setmenulist] = useState([]);
  const [submenulist, setsubmenulist] = useState([]);

  const MenuList = async () => {
    try {
      let res = await API?.post(
        "/bindLayout",
        {
          username: uid,
          uid: username,
          type: "SubAdminList",
          mainid: "",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("sss_menu", res?.data?.data);
      setmenulist(res?.data?.data);
    } catch (e) {
      if (e.response.status === 401) {
        handleLogout();
      } else {
        console.log("error Balance APi", e);
      }
    }
  };

  const SubMenuList = async () => {
    try {
      let res = await API?.post(
        "/bindLayout",
        {
          username: uid,
          uid: username,
          type: "main_react",
          mainid: "",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("sss_submenu", res?.data);
      setsubmenulist(res?.data?.data);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("error Balance APi", e);
      }
    }
  };

  // useEffect(() => {
  //   MenuList();
  //   SubMenuList();
  // }, []);

  return (
    <div>
      {/* <!-- Top Bar Start --> */}
      <div className="topbar">
        {/* <!-- LOGO --> */}
        <div className="topbar-left">
          <div className="text-center">
            <a href="#" className="logo">
              <img
                src="/assets/images/logo.png"
                style={{ width: "60px", height: "auto" }}
              />{" "}
            </a>
          </div>
        </div>
        {/* <!-- Button mobile view to collapse sidebar menu --> */}
        <div className="navbar navbar-default" role="navigation">
          <div className="container">
            <div className="">
              <div className="pull-left">
                <button
                  className="button-menu-mobile open-left"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <i className="fa fa-bars"></i>
                </button>
                <div
                  className="offcanvas offcanvas-start"
                  tabindex="-1"
                  id="offcanvasExample"
                  aria-labelledby="offcanvasExampleLabel"
                >
                  <div className="offcanvas-body pp-ip-pro">
                    <div className="topbar-left-1">
                      <div className="text-center">
                        <a href="#" className="logo">
                          <img
                            src="/assets/images/logo.png"
                            style={{ height: "45px", width: "50%" }}
                          />{" "}
                        </a>
                      </div>
                    </div>
                    <div className="left side-menu">
                      <div className="slimScrollDiv">
                        <div className="sidebar-inner slimscrollleft">
                          <div className="user-details">
                            <div className="pull-left">
                              <img
                                src="assets/images/avatar-1.jpg"
                                alt=""
                                className="thumb-md img-circle"
                              />
                            </div>
                            <div className="user-info">
                              <div className="dropdown">
                                <a
                                  href="#"
                                  className="dropdown-toggle"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <label id="lblname">Admin</label>
                                  {/* <span className="caret"></span> */}
                                </a>
                                <ul className="dropdown-menu">
                                  <li>
                                    <a href="/" onClick={() => handleLogout()}>
                                      <i className="md md-settings-power"></i>{" "}
                                      Logout
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <p className="text-muted m-0">Administrator</p>
                            </div>
                          </div>
                          {/* <!--- Divider --> */}
                          <div id="sidebar-menu">
                            <ul
                              className="accordion accordion-flush"
                              id="accordionFlushExample"
                            >
                              {menulist?.map((item, index) => {
                                return (
                                  <>
                                    <li className="has_sub" key={item.id}>
                                      <a
                                        className="waves-effect"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#flush-collapse${item.id}`}
                                        aria-expanded="false"
                                        aria-controls={`flush-collapse${item.id}`}
                                      >
                                        <i className="md md-account-box"></i>
                                        <span>{item.Name}</span>
                                      </a>

                                      <div
                                        id={`flush-collapse${item.id}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby="flush-heading1"
                                        data-bs-parent="#accordionFlushExample"
                                      >
                                        {submenulist.map((litem, lindex) => {
                                          return (
                                            <>
                                              {item.id === litem.main_manu ? (
                                                <div
                                                  className="accordion-body"
                                                  key={litem.id}
                                                >
                                                  <li>
                                                    <a
                                                      className="waves-effect waves-effect-1"
                                                      href={litem.link}
                                                    >
                                                      {litem.submenu}
                                                    </a>
                                                  </li>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          );
                                        })}
                                      </div>
                                    </li>
                                  </>
                                );
                              })}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne01"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne01"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Dashboard</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne01"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne01"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Dashboard"
                                      >
                                        Dashboard
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne1"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne1"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Member</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne1"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Member_Details"
                                      >
                                        All Member
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActiveMember"
                                      >
                                        Active Member
                                      </Link>
                                    </li>
                                    {/* <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/upgradeMember">
                                        Upgrade Member
                                      </Link>
                                    </li> */}
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Commission_Report"
                                      >
                                        InActive Member
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne2"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne2">
                                  <i className="md md-account-box"></i>
                                  <span>Fund</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne2"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne"
                                  data-bs-parent="#accordionFlushExample">
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/addpower">
                                        Add Fund
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/powerhistory">
                                        Add Fund History
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li> */}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne3"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne3"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Activation</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne3"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Activation"
                                      >
                                        Activation
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Activationhistory"
                                      >
                                        Activation History
                                      </Link>
                                    </li>
                                     <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActivationHistoryUser"
                                      >
                                        User Activation History
                                      </Link>
                                    </li>

                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActivationhistoryBasic"
                                      >
                                        Basic Activation History
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActivationhistoryBronze"
                                      >
                                        Bronze Activation History
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActivationhistoryGold"
                                      >
                                        Gold Activation History
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActivationhistoryPlatinum"
                                      >
                                        Platinum Activation History
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne03"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne03">
                                  <i className="md md-account-box"></i>
                                  <span>Activation Zero Pin</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne03"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne"
                                  data-bs-parent="#accordionFlushExample">
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/zeroFix">
                                        Activation FIX Zero
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/zeroFixhistory">
                                        Activation Fix Zero History
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Botactizero">
                                        Activation BOT Zero
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/zeroBothistory">
                                        Activation Bot Zero History
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li> */}
                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne4"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne4">
                                  <i className="md md-account-box"></i>
                                  <span>Roi</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne4"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne4"
                                  data-bs-parent="#accordionFlushExample">
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/roirate">
                                        Add Roi
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li> */}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne5"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne5"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>My Team</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne5"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne4"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    {/* <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/My_Team">
                                        My Downline
                                      </Link>
                                    </li> */}
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/myreferrals"
                                      >
                                        My Direct Team
                                      </Link>
                                    </li>

                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Level_detail"
                                      >
                                        Level Details
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne6"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne6"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Income Report</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne6"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne4"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    {/* <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/DirectIncome">
                                        Direct Income
                                      </Link>
                                    </li> */}
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/WithdrawalDeduct"
                                      >
                                        Withdrawal Wallet Deduct
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/RoiIncome"
                                      >
                                        Staking Reward
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/LevelIncome"
                                      >
                                        Staking Level Reward
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/DirectIncomeWorking"
                                      >
                                        Working Direct Reward
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/LevelIncomeWorking"
                                      >
                                        Working Level Reward
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Total_incomeReport"
                                      >
                                        Total Income Report
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne99"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne99">
                                  <i className="md md-account-box"></i>
                                  <span>Help Desk</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne99"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne4"
                                  data-bs-parent="#accordionFlushExample">
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/HelpDesk">
                                        Help Desk
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ClosedHelpDesk">
                                        Closed Help Desk
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li> */}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne88"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne88"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Claim</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne88"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne4"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/PendingClaimActvationHistory"
                                      >
                                        Pending Claim Actvation History
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/PaidClaimActvationHistory"
                                      >
                                        Paid Claim Actvation History
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne8"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne8"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Withdrawal</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne8"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne4"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Pending_Withdrawal"
                                      >
                                        Pending Withdrawal
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/Withdrawal_History"
                                      >
                                        Withdrawal History
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/PendingUsdWithdrawal"
                                      >
                                        Pending Working Withdrawal
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/PaidUsdWithdrawal"
                                      >
                                        Working Withdrawal History
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseTen"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseTen"
                                  href="/"
                                  onClick={() => handleLogout()}
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Log-Out</span>
                                </a>
                              </li>
                            </ul>
                            <div className="clearfix"></div>
                            <div className="clearfix"></div>
                          </div>
                        </div>
                        <div
                          className="slimScrollBar"
                          style={{
                            background: "rgb(122, 134, 143)",
                            width: "5px",
                            position: "absolute",
                            top: "0px",
                            opacity: "0.4",
                            display: "none",
                            borderRadius: "7px",
                            zIndex: "99",
                            right: "1px",
                            height: "1305px",
                            visibility: "visible",
                          }}
                        ></div>
                        <div
                          className="slimScrollRail"
                          style={{
                            width: "5px",
                            height: "100%",
                            position: "absolute",
                            top: "0px",
                            display: "none",
                            borderadius: "7px",
                            background: "rgb(51, 51, 51)",
                            opacity: "0.2",
                            zIndex: "90",
                            right: "1px",
                          }}
                        ></div>
                      </div>
                      {/* <!-- Left Sidebar End --> */}
                    </div>
                  </div>
                </div>
                <span className="clearfix"></span>
              </div>
              <ul className="nav navbar-nav navbar-right pull-right">
                <li className="dropdown pp-pro">
                  <a
                    href="#"
                    className="dropdown-toggle profile"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img
                      src="assets/images/avatar-1.jpg"
                      alt="user-img"
                      className="img-circle"
                    />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a href="/" onClick={() => handleLogout()}>
                        <i className="md md-settings-power"></i> Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            {/* <!--/.nav-collapse --> */}
          </div>
        </div>
      </div>
      {/* <!-- Top Bar End --> */}
    </div>
  );
}

export default Navbar;
